import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

interface DashboardViewToggleProps {
  isMapView: boolean;
  onViewChange: (isMapView: boolean) => void;
  className?: string;
  showAnalysis?: boolean;
  isAnalysisView?: boolean;
  onAnalysisViewChange?: (isAnalysisView: boolean) => void;
}

const TAB_CLASS =
  "data-[state=active]:bg-secondary-selected data-[state=active]:text-secondary-foreground data-[state=active]:shadow-none";

export function DashboardViewToggle({
  isMapView,
  onViewChange,
  className,
  showAnalysis = false,
  isAnalysisView = false,
  onAnalysisViewChange,
}: DashboardViewToggleProps) {
  const value = isAnalysisView ? "analysis" : isMapView ? "map" : "list";
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Tabs
        value={value}
        onValueChange={(next) => {
          if (next === "analysis") {
            onAnalysisViewChange?.(true);
            onViewChange(false);
            return;
          }
          onAnalysisViewChange?.(false);
          onViewChange(next === "map");
        }}
      >
        <TabsList className="bg-card" data-active-chrome="secondary">
          <TabsTrigger className={TAB_CLASS} value="list">
            List
          </TabsTrigger>
          <TabsTrigger className={TAB_CLASS} value="map">
            Map
          </TabsTrigger>
          {showAnalysis ? (
            <TabsTrigger className={TAB_CLASS} value="analysis">
              Analysis
            </TabsTrigger>
          ) : null}
        </TabsList>
      </Tabs>
    </div>
  );
}
